import { Flex } from "antd";
import { useState, useEffect, useRef } from "react";
import { useI18n } from "@/contexts/I18nContext";
import styles from "./index.module.scss";

const ScrollLinkList = ({ settingObj }: any) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [showLeftBtn, setShowLeftBtn] = useState(false);
  const [showRightBtn, setShowRightBtn] = useState(true);
  const { locale, isRtl } = useI18n();

  // 更新箭头可见性
  const updateArrowVisibility = () => {
    if (!scrollContainerRef.current) return;

    const container = scrollContainerRef.current;
    const scrollLeft = container.scrollLeft;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    setShowLeftBtn(scrollLeft > 0);
    setShowRightBtn(Math.ceil(scrollLeft) < maxScrollLeft);
  };

  // 左箭头点击事件
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current?.scrollBy({
        left: isRtl ? 124 : -124,
        behavior: "smooth",
      });
    }
  };

  // 右箭头点击事件
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current?.scrollBy({
        left: isRtl ? -124 : 124,
        behavior: "smooth",
      });
    }
  };

  // 添加滚动事件监听
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      updateArrowVisibility();
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // 监听窗口大小变化和语言切换
  useEffect(() => {
    // 初始更新
    updateArrowVisibility();

    // 添加窗口大小变化监听
    const handleResize = () => {
      updateArrowVisibility();
    };

    window.addEventListener("resize", handleResize);

    // 清理函数
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [locale]);

  // 监听 settingObj 变化（链接内容变化）
  useEffect(() => {
    // 使用 setTimeout 确保在 DOM 更新后执行
    const timer = setTimeout(() => {
      updateArrowVisibility();
    }, 0);

    return () => clearTimeout(timer);
  }, [settingObj]);

  return (
    <div className={styles.linksScrollContainer}>
      <Flex justify="center" className={styles.container}>
        {/* 左滚动按钮 */}
        <button
          className={`${styles.scrollBtn} ${styles.leftBtn}
              ${showLeftBtn ? styles.show : styles.hidden}`}
          onClick={scrollLeft}
          aria-label="向左滚动"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        {/* 滚动容器 */}
        <div ref={scrollContainerRef} className={styles.scrollContainer}>
          <div className={styles.buttonGroup}>
            {settingObj?.links &&
              settingObj?.links?.map(
                (item: { url: string; text: string }, index: number) => (
                  <a
                    key={index}
                    id="link_to_agent_button"
                    className={styles.categoryBtn}
                    target="_blank"
                    rel="noreferrer"
                    href={item.url || "#"}
                    onClick={!item.url ? (e) => e.preventDefault() : undefined}
                    data-track-element
                  >
                    {item.text}
                  </a>
                ),
              )}
          </div>
        </div>
        {/* 右滚动按钮 */}
        <button
          className={`${styles.scrollBtn} ${styles.rightBtn}
              ${showRightBtn ? styles.show : styles.hidden} `}
          onClick={scrollRight}
          aria-label="向右滚动"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </Flex>
    </div>
  );
};

export default ScrollLinkList;
